import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from 'react-icons/fi';

export const aboutUs = {
  pageHeroAboutUs:{
    pageHero:{
      title: null,
      subtitle: null,
      mainImg: '/images/pages/home-banner-baby.png',
      decorImg: '/images/decor/decor_image_green.svg',
    }
  },
  
  heroTitle: {
    title: null,
    subtitle: null,
    mainImg: { file: '/images/pages/home-banner-baby.png', alt: 'About us intro image' },
    decorImg: { file: '/images/decor/decor_image_green.svg', alt: 'green decoration image' },
  },

  ourCompany: {
    id: 'our-company',
    title: 'Who We Are',
    subtitle: 'Atlantic Labs is a preventative health care company that leverages innovative technologies to bring state of the art genomic testing direct to consumers. The core of our laboratory infrastructure is our approach to genetic testing, we have developed innovative, genetic testing solutions that analyze a higher number of gene markers than most laboratories.',
    desc: [
      'Atlantic Labs Laboratory provides custom pathology and genetic testing solutions by tailoring all of our services to your specific needs. Through an integrated and personalized approach, we will bring you the most accurate and timely results possible.',
    ],
    ourMission: {
      title: 'Our Mission',
      desc: [
        'It is the mission of Atlantic Labs and its sister companies to ensure the most efficient and effective diagnostic patient care possible. This includes producing accurate, timely, comprehensive, and completely validated analytical results for physicians and healthcare providers across the country.',
        'We’re providing patients with quality genetic testing & Pathology solutions through an integrated and personalized approach to improve their chances of living a happy and healthier life.',
      ],
    },
  },

  meetTheTeam: [
  // Juliet Blevins
    {
      card: {
        img: '/images/team/JulietB.jpg',
        name: ['Juliet Blevins', <span style={{color:'#fff'}}>.</span>],
        position: 'Office Manager',
        specialty: [' ', ' '],
        location: 'TX, USA',
        description: 'a Curriculum  Vitae',
        turnOnSocial: false,
        socialNetwork: [
          {
            icon: <FiFacebook />,
            url: '#',
          },
          {
            icon: <FiTwitter />,
            url: '#',
          },
          {
            icon: <FiInstagram />,
            url: '#',
          },
        ],
      },
  
      popup: {
        img: '/images/team/JulietB.jpg',
        name: 'Juliet Blevins',
        position: 'Office Manager',
        specialty: ' ',
        desc: [
          {
            listTitle: null,
            list: [
              'Juliet is from Killeen, TX. She was initially brought to Dallas in 2013 for a teaching position at Garland High School after completing her BFA from Texas State University. She taught for two years before pivoting into dentistry. Throughout her dentistry career she has worked as a registered dental assistant, treatment coordinator, and an office manager. With over 7 years of experience in private dental practices, Juliet has extensive knowledge in the fields of administration and patient care. She enjoys the challenges and rewards that come with the daily operations of an office.  She joined Atlantic Labs in 2022.'
            ],
          },
        ],
      },
    },
  // Alexa Vandenburg
    {
      card: {
        img: '/images/team/AlexaV.jpg',
        name: ['Alexa Vandenburg', 'MB(ASCP)'],
        position: 'Molecular Medical Technologist',
        specialty: [''],
        location: 'TX, USA',
        description: 'a Curriculum  Vitae',
        turnOnSocial: false,
        socialNetwork: [
          {
            icon: <FiFacebook />,
            url: '#',
          },
          {
            icon: <FiTwitter />,
            url: '#',
          },
          {
            icon: <FiInstagram />,
            url: '#',
          },
        ],
      },
  
      popup: {
        img: '/images/team/AlexaV.jpg',
        name: 'Alexa Vandenburg, MB(ASCP)',
        position: 'Molecular Medical Technologist',
        specialty: null,
        desc: [
          {
            listTitle: null,
            list: [
              'Alexa is an Orange County California native who has resided in Dallas after graduating from SMU with a B.S. in Biology and a double minor in Neuroscience and Cognitive Science. She is a published research assistant whose main studies at SMU focused on exploring the impacts of RNA binding protein combinations in neuronal function and behavior primarily by using fluorescent reporters to visualize splicing events as well as the consequential phenotype that follows. Carrying over a strong research-based background and wanting to dig deeper into the clinical side of molecular genetics after graduating, Alexa became a board certified Molecular Medical Technologist with a current MB (ASCP) certification. As her 3rd ongoing year in a high complexity testing lab, Alexa has become highly proficient in conducting and analyzing Next Generation Sequencing assays with a high level of accuracy. Whether it is research or diagnostic, genetics is a very powerful tool that leads to a better understanding of prognosis, predictions, and treatment for the patient.',
            ],
          },
        ],
      },
    },
  // Megan Airgood
    {
      card: {
        img: '/images/team/MeganA.jpg',
        name: ['Megan Airgood', 'MB(ASCP)'],
        position: 'Molecular Medical Technologist',
        specialty: [''],
        location: 'TX, USA',
        description: 'a Curriculum  Vitae',
        turnOnSocial: false,
        socialNetwork: [
          {
            icon: <FiFacebook />,
            url: '#',
          },
          {
            icon: <FiTwitter />,
            url: '#',
          },
          {
            icon: <FiInstagram />,
            url: '#',
          },
        ],
      },
  
      popup: {
        img: '/images/team/MeganA.jpg',
        name: 'Megan Airgood, MB(ASCP)',
        position: 'Molecular Medical Technologist',
        specialty: '',
        desc: [
          {
            listTitle: null,
            list: [
              'Megan was born and raised in small town Ligonier, Indiana. She went to Purdue University and earned a B.S in Molecular Biology and an A.S in Chemistry. At university she joined Dr. Mustafa’s research team where they researched and discovered new fish nutraceuticals to use in large scale fish farming. The research team went on to showcase the new discoveries at the Worldwide Aquaponics Conference. She also participated in Dr. Palu’s Genetics lab where she began learning useful clinical genetics skills. After graduation, Megan moved to Dallas Texas to pursue her dream of working in cancer genetics at Atlantic Laboratory performing high complexity testing. From there, she studied and obtained her ASCP board certification in Molecular Biology. She plans to further her career by leaning into management type roles in the lab setting where she can further her growth.'
            ],
          },
        ],
      },
    },
  ],

  AtlanticLabsAffordable: {
    picTextArea: {
      img: '/images/pages/about-us-lab-tube.jfif',
      imgMobile: '/images/pages/about-us-lab-tube.jfif',
      regularTitle: 'Atlantic Labs Is Affordable, within Reach and Accurate',
      largeTitle: null,
      specialTitle: null,
      subtitle: null,
      p: [
        'Atlantic Labs lab is accredited by the Clinical Laboratory Improvement Amendments of 1988 (CLIA). A CLIA-Certified lab must meet specific quality standards, including qualifications for individuals who perform the test and other standards that ensure the accuracy and reliability of results.',
        'Our Nextseq2000 System is a genetic sequencer from Illumina, that provides High quality next-generation sequencing (NGS) technology with a fast turn around on results.',
        'Atlantic Labs accepts most major insurance plans, allowing your office the opportunity to consolidate the number of labs you are using. All client billing is managed confidentially and professionally. Our extensive participation list ensures that you can have one primary laboratory that takes care of all you patients’ need.',
      ],
      btn: {type:'external_link', link: 'http://i-pathology.net/doc/insurancelist-2016.pdf', text: 'Insurance List' },
    },
    abideLogos: {
      title: 'Proud to Work with & Adhere to:',
      logos: [
        [
          {
            img: '/images/partners/CLIA.png',
            alt: 'CLIA-logo',
          },
          {
            img: '/images/partners/OSHA.png',
            alt: 'OSHA-logo',
          },
          {
            img: '/images/partners/ILLUMINA.png',
            alt: 'ILLUMINA-logo',
          },
        ],
        [
          {
            img: '/images/partners/HIPAA.png',
            alt: 'HIPAA-logo',
          },
          {
            img: '/images/partners/CMS.png',
            alt: 'CMS-logo',
          },
          {
            img: '/images/partners/MEDICAID.png',
            alt: 'MEDICAID-logo',
          },
        ],
      ],
    },
  },
};
